import { EntitySearchFilterBar } from 'src/components/EntitySearch';
import { FilterDropdownItem } from 'src/components/Filters';
import { useSaleFilters } from 'src/components/MainFilterBar/AdvancedSearch/useSaleFilters';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature, SaleQueryV2, SaleSearchResult } from 'src/WebApiController';

export const SaleSearchFilterBar = (props: {
  activeSearchConfig?: SaleSearchResult;
  onSubmitFilter?: (query: SaleQueryV2) => void;
  selectedFilters?: FilterDropdownItem[];
  setSelectedFilters: (sf: FilterDropdownItem[]) => void;
}) => {
  const hasSearchViewPerformerFilterFeature = useUserHasFeature(
    Feature.SearchViewPerformerFilter
  );

  const { filters } = useSaleFilters({
    supportMultiOperation: true,
    showCatalogFilters: true,
    showVenueFilter: true,
    showPerformerFilter: hasSearchViewPerformerFilterFeature,
    isHorizontalLayout: true,
    firstRenderOpen: props.activeSearchConfig == null,
  });

  return (
    <EntitySearchFilterBar
      {...props}
      filters={filters}
      mandatoryFiltersToShow={['eventDates', 'eventOrMappingIds']}
    />
  );
};
